import React from 'react'

import AboutHeader from "../../Component/aboutus/aboutusheader/AboutHeader"
import AboutSectionone from "../../Component/aboutus/aboutsectionone/Aboutsectionone"
import AboutSectiontwo from "../../Component/aboutus/aboutsectiontwo/Aboutsectiontwo"
import AboutFooter from "../../Component/aboutus/aboutfooter/Aboutfooter"


 function Aboutuspage() {
    //  console.log("About us", About_Section_2 )

    return (
        <div>
            <AboutHeader />
            <AboutSectionone />
            <AboutSectiontwo />
            <AboutFooter />
        </div>
    )
}


export default Aboutuspage; 